import React from 'react';
import CampaignSearch from './components/CampaignSearch';
import UiState from './stores/UiState';
const CampaignsSearch = (props) => {
  const store = new UiState(props);
  return (
    <div className="my-8">
      <CampaignSearch store={store} />
    </div>
  );
};

export default CampaignsSearch;
